import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import SoldxHeader from "../../../components/SoldxHeader"
import SoldxLandingFooter from "../../../components/SoldxLandingFooter"
import SoldxBreadcrumb from "../../../components/SoldxBreadcrumb"

const HERO_IMG =
  "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=800&h=600&fit=crop"
const CLOSE_IMG =
  "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=500&fit=crop"
const FORM_IMG =
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=500&fit=crop"

const Buyer = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    mobile: "",
    state: "Delhi",
    query: "",
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // TODO: submit to API
  }

  return (
    <div className="soldx-landing soldx-buyer-page">
      <SoldxHeader solid />

      {/* Hero: rounded blue gradient box + image */}
      <section className="soldx-buyer-hero soldx-hero-modern">
        <div className="soldx-hero-modern-inner">
          <div className="soldx-hero-modern-card">
            <SoldxBreadcrumb variant="hero" heroTone="dark" className="mb-5" />
            <p className="soldx-hero-modern-slogan">Your Gateway to Prime Assets</p>
            <h1 className="soldx-hero-modern-title">
              <span className="soldx-hero-modern-title-bold">Unlock the Best Deals</span>
              <span className="soldx-hero-modern-title-italic">in Smart Investment</span>
              <span className="soldx-hero-modern-title-bold">Today</span>
            </h1>
            <Link to="/properties" className="soldx-hero-modern-cta">
              GET STARTED
            </Link>
          </div>
          <div className="soldx-hero-modern-img">
            <img src={HERO_IMG} alt="Commercial real estate" />
          </div>
        </div>
      </section>

      {/* Maximize Your Investment Potential */}
      <section className="soldx-buyer-section soldx-buyer-invest">
        <Container>
          <div className="soldx-buyer-invest-inner">
            <h2 className="soldx-buyer-section-title">Maximize Your Investment Potential</h2>
            <p className="soldx-buyer-section-sub">The Ultimate Real Estate Auction Platform</p>
            <p className="soldx-buyer-section-text">
              SOLDX offers you the tools to make confident, informed decisions. With real-time bidding,
              transparent property details, and nationwide access, you can find and win the right
              commercial assets for your portfolio.
            </p>
            <Link to="/properties" className="soldx-buyer-btn soldx-buyer-btn-primary">
              GET STARTED
            </Link>
          </div>
        </Container>
      </section>

      {/* How Our Auction Works */}
      <section className="soldx-buyer-section soldx-buyer-auction-steps">
        <Container>
          <h2 className="soldx-buyer-steps-title">How Our Auction Works</h2>
          <Row className="g-4 justify-content-center">
            <Col md={6} lg={4}>
              <div className="soldx-buyer-step-card">
                <span className="soldx-buyer-step-label">Register For Auction</span>
              </div>
            </Col>
            <Col md={6} lg={4}>
              <div className="soldx-buyer-step-card">
                <span className="soldx-buyer-step-label">Place Bids</span>
              </div>
            </Col>
            <Col md={6} lg={4}>
              <div className="soldx-buyer-step-card">
                <span className="soldx-buyer-step-label">Real Time Updates</span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Discover how SoldX helps you close faster */}
      <section className="soldx-buyer-section soldx-buyer-close">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={5}>
              <div className="soldx-buyer-close-img">
                <img src={CLOSE_IMG} alt="Closing transactions" />
              </div>
            </Col>
            <Col lg={7} className="d-flex align-items-center">
              <div>
                <h2 className="soldx-buyer-close-title">
                  Discover how SoldX helps you close transactions faster and with greater certainty.
                </h2>
                <Link to="/properties" className="soldx-buyer-btn soldx-buyer-btn-primary">
                  Start Bidding
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact / Learn More Form */}
      <section className="soldx-buyer-section soldx-buyer-form-section">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <div className="soldx-buyer-form-wrap">
                <h2 className="soldx-buyer-form-title">
                  Learn More About How Soldx Help You Close More Transactions Faster And With Certainty.
                </h2>
                <p className="soldx-buyer-form-sub">Personalize your deals.</p>
                <form onSubmit={handleSubmit} className="soldx-buyer-form">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={form.name}
                    onChange={handleChange}
                    className="soldx-buyer-input"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={form.email}
                    onChange={handleChange}
                    className="soldx-buyer-input"
                  />
                  <input
                    type="text"
                    name="company"
                    placeholder="Company Name"
                    value={form.company}
                    onChange={handleChange}
                    className="soldx-buyer-input"
                  />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Phone"
                    value={form.mobile}
                    onChange={handleChange}
                    className="soldx-buyer-input"
                  />
                  <select
                    name="state"
                    value={form.state}
                    onChange={handleChange}
                    className="soldx-buyer-input soldx-buyer-select"
                  >
                    <option value="Delhi">Delhi</option>
                    <option value="Maharashtra">Maharashtra</option>
                    <option value="Karnataka">Karnataka</option>
                    <option value="Tamil Nadu">Tamil Nadu</option>
                    <option value="Other">Other</option>
                  </select>
                  <textarea
                    name="query"
                    placeholder="Your Query"
                    value={form.query}
                    onChange={handleChange}
                    rows={4}
                    className="soldx-buyer-input soldx-buyer-textarea"
                  />
                  <button type="submit" className="soldx-buyer-btn soldx-buyer-btn-primary">
                    GET STARTED
                  </button>
                </form>
              </div>
            </Col>
            <Col lg={6}>
              <div className="soldx-buyer-form-img">
                <img src={FORM_IMG} alt="Properties" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <SoldxLandingFooter />
    </div>
  )
}

export default Buyer
